import { LaneGroup } from './laneGroups';

const firstFilled = (labels: readonly string[]): string | null =>
  labels.find((label) => label.trim().length > 0) ?? null;

/**
 * レーンカードの見出し。降地の名称だけを出す。
 *
 * Why not「積地 → 降地」の区間表記: 右パネルの幅（実測 291px）では両端とも
 * 省略記号に埋もれ、肝心の降地が読めなくなる（ユーザー判断）。積地は info アイコンで
 * 開く詳細パネルで見せる。
 *
 * 降地が引けないときだけ積地で代替する（見出しが空になるより手掛かりを残す）。
 * 複数あっても先頭で代表するのは、同一レーンでも名称が揺れることがあり
 * （住所は同じで表記違いなど）、全件連結すると幅を食うため。
 */
export function buildLaneLabel(group: LaneGroup): string {
  return firstFilled(group.destinationLabels) ?? firstFilled(group.originLabels) ?? '—';
}
